import dayjs from 'dayjs';

export const getChipValue = (field, value) => {
    return `${field}: ${value}`;
};

export const mapValueId = (value) => value.map((value) => value.id);

export const mapChipsName = (name, value) =>
    value.map((type) => getChipValue(name, type.name));

export const fetchOptionsByName = (callback) => {
    return async ({ query: name } = {}) => {
        return (
            await callback({
                name,
                orderField: 'name',
                order: 'asc',
            })
        ).results;
    };
};

export const filterValueByName = (valueList, value) => valueList.filter((v) => v.name !== value);

export const buildDateRangeFilter = (value) => {
    if (!value.find((val) => val)) {
        return undefined;
    }
    const start = value[0]
        ? dayjs(value[0]).format('YYYY-MM-DD')
        : null;
    const end = value[1] ? dayjs(value[1]).format('YYYY-MM-DD') : null;
    return (end ? [start || 0, end] : [start]).join(',');
};

export const buildDateRangeChips = (name, value) => {
    if (!value.find((val) => val)) {
        return [];
    }
    const formattedValue = value
        .filter((date) => date)
        .map((date) => dayjs(date).format('DD/MM/YYYY'))
        .join(' - ');
    return [getChipValue(name, formattedValue)];
};

export const timeUnitOptions = [
    { name: 'Dias', value: 'd' },
    { name: 'Meses', value: 'M' },
    { name: 'Anos', value: 'y' },
];

export function useTextFilter(name = 'Termo', valueKey = 'term') {
    return {
        value: '',
        name,
        query: (value) => ({ [valueKey]: value }),
        chips: (name, value) => [getChipValue(name, value)],
        removeValue: () => '',
    };
}

export function useTermFilter() {
    return {
        value: [],
        name: 'Termo',
        query: (value) => ({ term: value }),
        chips: (name, value) => value.map((term) => getChipValue(name, term)),
        removeValue: (valueList, value) => valueList.filter((t) => t !== value),
    };
}

export function useIdsFilter(name, valueKey, nameKey, fetchCallback) {
    return {
        value: [],
        name,
        options: [],
        fetchOptions: async (event = {}, _, apiOptions) => {
            const query = {
                [nameKey]: event.query,
                orderField: nameKey,
                order: 'asc',
            };
            return (await fetchCallback(query, apiOptions)).results;
        },
        query: (value) => {
            value = Array.isArray(value) ? value : [value];
            return { [valueKey]: mapValueId(value) };
        },
        chips: (name, value) => {
            value = Array.isArray(value) ? value : [value];
            return value.map((type) => getChipValue(name, type.name));
        },
        removeValue: (valueList, value) => {
            valueList = Array.isArray(valueList) ? valueList : [valueList];
            return valueList.filter((v) => v[nameKey] !== value);
        },
    };
}

export function useDateRangeFilter(name = 'Cadastro', valueKey = 'createdAt') {
    return {
        value: [null, null],
        name,
        query: (value) => ({ [valueKey]: buildDateRangeFilter(value) }),
        chips: buildDateRangeChips,
        removeValue: () => [null, null],
    };
}

export function useValueRangeFilter(name, valueKey) {
    return {
        value: [null, null],
        name,
        query: (value) => {
            if (!value[0] && !value[1]) {
                return {};
            }
            return { [valueKey]: value.join(',') };
        },
        chips: (name, value) => {
            if (!value[0] && !value[1]) {
                return [];
            }
            if (!value[1]) {
                return [getChipValue(name, value[0])];
            }
            const values = value.map(val => (val || 0).toLocaleString()).join(' - ');
            return [getChipValue(name, values)];
        },
        removeValue: () => [null, null],
    };
}

export function buildQuery(searchFilters, searchOrder) {
    const query = {};
    const chips = [];

    Object.keys(searchFilters).forEach((key) => {
        const option = searchFilters[key];
        if (
            (Array.isArray(option.value) && !option.value.length) ||
            (!Array.isArray(option.value) && !option.value)
        ) {
            return;
        }
        if (option.query) {
            Object.assign(query, option.query(option.value));
        }
        if (option.chips) {
            chips.push(...option.chips(option.name, option.value));
        }
    });

    if (searchOrder.orderField?.value) {
        query.orderField = searchOrder.orderField?.value;
    }

    if (searchOrder.order) {
        query.order = searchOrder?.order;
    }

    return { query, chips };
}
